import { SGGraphics } from "sg-consts";
import { getWinningSymbols } from "slotworks/commands/symbols/get-winning-symbols-command";
import Layers from "slotworks/graphics/layers/layers";
import Result from "slotworks/model/gameplay/records/results/result";
import * as TweenJS from "slotworks/utils/tween";

class BackgroundTint {
    constructor() {
        Layers.MatrixBackground.onSceneEnter.add((scene: string) => {
            const shape = Layers.MatrixContent.getShape(SGGraphics.MatrixContent.disco);
            if (shape) {
                this.hide();
            }
        });
    }

    public show(): void {
        const shape = Layers.MatrixContent.getShape(SGGraphics.MatrixContent.disco);
        TweenJS.removeAll(shape);
        if (shape.alpha === 0) {
            new TweenJS.Tween(shape)
                .to({ alpha: 1 }, 150)
                .start();
        }
    }

    public hide(): void {
        const shape = Layers.MatrixContent.getShape(SGGraphics.MatrixContent.disco);
        TweenJS.removeAll(shape);
        new TweenJS.Tween(shape)
            .to({ alpha: 0 }, 150)
            .start();
    }

    public updateDepth(results: Result[]): void {
        const shape = Layers.MatrixContent.getShape(SGGraphics.MatrixContent.disco);
        Layers.MatrixContent.add(shape);

        if (results) {
            getWinningSymbols(results).forEach((symbol) => symbol.moveToTop());
        }
    }

}

export default new BackgroundTint();
